import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import global_en from "./locales/en/global.json";
import global_ar from "./locales/ar/global.json";
import global_fr from "./locales/fr/global.json";
import global_pr from "./locales/pr/global.json";
import global_sp from "./locales/sp/global.json";
import global_swc from "./locales/swc/global.json";
import { lang } from "./utils/constant";

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    interpolation: { escapeValue: false },
    lng: lang, // Default language
    fallback: lang,
    resources: {
      en: { global: global_en },
      fr: { global: global_fr },
      pr: { global: global_pr },
      sp: { global: global_sp },
      swc: { global: global_swc },
      ar: { global: global_ar },
    },
  });

export default i18n;
